export enum StoreCopyItem {
  STORE_SETTINGS = "STORE_SETTINGS",
  UNITS = "UNITS",
  COURSES = "COURSES",
  SUPPLIERS = "SUPPLIERS",
  BOOKKEEPING_ACCOUNTS = "BOOKKEEPING_ACCOUNTS",
  PREP_STATIONS = "PREP_STATIONS",
  PRODUCT_GROUPS = "PRODUCT_GROUPS",
  MODIFIER_GROUPS = "MODIFIER_GROUPS",
  MODIFIERS = "MODIFIERS",
  PRODUCTS = "PRODUCTS",
  OFFERS = "OFFERS",
  PRODUCT_PAGES = "PRODUCT_PAGES",
  LAYOUTS = "LAYOUTS",
  PRINTERS = "PRINTERS",
  BARCODE_FORMATS = "BARCODE_FORMATS",
  FLOOR_PLANS = "FLOOR_PLANS",
  DEVICE_CONFIGS = "DEVICE_CONFIGS",
}
